import React from 'react';
import { SelectList } from 'components/selectList/selectList';
import { InputText } from 'components/inputText/inputText';
import { maxLenghtByDocument, extraValidationByDocument } from 'utilities/logicByCountry';
import { setPlaceHolderDocTypeByCountry } from 'utilities/multiLanguageHelper';
import { getValidation } from 'commonsUtilities/validations';
import { formatText, FormattedText } from 'core/i18n';
import { InfoTooltip } from 'components/tooltip/tooltip';
import {
    getReferenceTooltipDocumentTypeByCountry,
    getReferenceOptionsDocumentTypeByCountry,
} from 'utilities/multiLanguageHelper';
import { validateDocNumber } from '../../validations/docNumber';

export const ID = ({
    focus,
    formActions,
    setIdValid,
    submitButtonValidations,
    userProfile,
    userProfileForm,
    validateSecondLastName,
    disabled,
    isSelectorDisabled,
    onFocus,
}) => {
    const handleIDChange = () => {
        formActions.setValidity('userProfile.documentType', { required: true });
        submitButtonValidations?.();
    };

    const doDocNumberValidation = () => {
        const { docNumber, documentType } = userProfile;

        if (docNumber) {
            formActions.validate('userProfile.docNumber', {
                valid: () => {
                    const isValid = validateDocNumber({ docNumber, documentType });
                    setIdValid?.(isValid);

                    return isValid;
                },
            });
        } else {
            setIdValid?.(false);
        }
    };

    return (
        <div className="row form__input md-form-group">
            <div className="col-lg-12">
                <label htmlFor="docNumber">{formatText('field-documentNumber')}</label>
                <InfoTooltip
                    text={<FormattedText value={getReferenceTooltipDocumentTypeByCountry()} />}
                    alt={'id-input'}
                />
            </div>
            <div className="col-sm-6">
                <div className="form__group-inputs">
                    <div className="row">
                        <div className="col-xs-4 first-col form-dni-select">
                            <SelectList
                                value={getReferenceOptionsDocumentTypeByCountry()[0].value}
                                autofocus={focus.get('documentType')}
                                profileModel="userProfile.documentType"
                                name="documentType"
                                optionsList={getReferenceOptionsDocumentTypeByCountry()}
                                clearable={false}
                                placeholder=""
                                messagesError={{
                                    required: formatText('validation-selectDocumentType'),
                                }}
                                required
                                isUpdated={() => {
                                    handleIDChange();
                                    validateSecondLastName('secondLastName');
                                    doDocNumberValidation();
                                }}
                                userProfile={userProfile}
                                userProfileForm={userProfileForm}
                                formActions={formActions}
                                disabled={isSelectorDisabled}
                            />
                        </div>
                        <div className="col-xs-8 last-col">
                            <InputText
                                profileModel="userProfile.docNumber"
                                placeholder={formatText(setPlaceHolderDocTypeByCountry(userProfile.documentType))}
                                type="text"
                                inputMode="text"
                                name="docNumber"
                                id="docNumber"
                                disabled={disabled}
                                maxLength={maxLenghtByDocument(userProfile.documentType)}
                                defaultValue={userProfile.docNumber}
                                validations={{
                                    required: value => value && value.length,
                                    valid: value => {
                                        const validation = getValidation(value, userProfile.documentType);
                                        const { haveExtraValidation, extraValidation } = extraValidationByDocument(
                                            value,
                                            userProfile.documentType
                                        );
                                        const extraValid = haveExtraValidation ? extraValidation : true;
                                        setIdValid?.(validation.valid && extraValid);

                                        return validation.valid && extraValid;
                                    },
                                }}
                                onBlur={value => {
                                    return value.toUpperCase();
                                }}
                                isNotValidated={() => setIdValid?.(false)}
                                isValidated={() => submitButtonValidations?.(true)}
                                messagesError={{
                                    required: formatText('validation-fieldRequired'),
                                    valid: value => {
                                        const { extraValidationError } = extraValidationByDocument(
                                            value,
                                            userProfile.documentType
                                        );

                                        return extraValidationError
                                            ? formatText(extraValidationError)
                                            : formatText('validation-syntaxErrorDocument');
                                    },
                                }}
                                userProfileForm={userProfileForm}
                                userProfile={userProfile}
                                formActions={formActions}
                                onFocus={onFocus}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
